export default __webpack_public_path__ + "static/media/app_icon_512.81d6199c.png";